import { render, staticRenderFns } from "./GeneralTabCardsSection.vue?vue&type=template&id=1ced26b4&scoped=true&"
import script from "./GeneralTabCardsSection.vue?vue&type=script&lang=js&"
export * from "./GeneralTabCardsSection.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTabCardsSection.vue?vue&type=style&index=0&id=1ced26b4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ced26b4",
  null
  
)

export default component.exports